import { Outlet } from 'react-router';

import { HeaderToolbarAndContentLayout } from 'src/common/primitives/HeaderToolbarAndContentLayout';

import { AdminRouteActions } from './AdminRouteActions';

export function AdminLayout() {
  return (
    <HeaderToolbarAndContentLayout
      preContent={<div />}
      actionSection={<AdminRouteActions />}
      content={<Outlet />}
    />
  );
}
